<template>
  <div>
    <el-dialog
      title="学生信息详情"
      :visible.sync="dialogVisible"
      @close="$emit('setzero')"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="first">
          <table
            class="
              myTable
              el-table
              el-table--fit
              el-table--striped
              el-table--border
              el-table--enable-row-hover
              el-table--enable-row-transition
            "
            style="width: 100%"
          >
            <tr>
              <td>姓名：{{ info.realName }}</td>
              <td>性别：{{ info.sex ? "男" : "女" }}</td>
            </tr>
            <tr>
              <td>添加时间：{{ info.inputTime ? String(info.inputTime).substring(0, 10) : '' }}</td>
              <td>年龄：{{ info.age != null ? info.age : '' }}</td>
            </tr>
            <tr>
              <td>跟进状态：{{ info.state != null && info.state !== '' ? info.state : '' }}</td>
              <td>学生/家长：{{ info.studentType || '' }}</td>
            </tr>
            <tr>
              <td>来源：{{ info.origin || '' }} {{ info.originRemark || '' }} {{ info.recName || '' }}</td>
              <td>计划赴日：{{ info.abroadPlan || '' }}</td>
            </tr>
            <tr>
              <td>留学时间：{{ info.abroadDate || '' }}</td>
              <td>学历：{{ info.eduBack || '' }}</td>
            </tr>
            <tr>
              <td>微信：{{ info.wechat || '' }}</td>
              <td>QQ：{{ info.qq != null && info.qq !== '' ? info.qq : '' }}</td>
            </tr>
            <tr>
              <td>电话：{{ info.mobile || '' }}</td>
              <td>地区：{{ (info.zzProvinceName || '') + (info.zzCityName || '') }}</td>
            </tr>
            <tr>
              <td>日语等级：{{ info.japaneseBase || '' }}</td>
              <td>日语：{{ info.japanese || '' }}</td>
            </tr>
            <tr>
              <td>英语：{{ info.english || '' }}</td>
              <td></td>
            </tr>
            <tr>
              <td colspan="2">目前状况：{{ info.followSummary || '' }}</td>
            </tr>
            <tr v-if="info.isStudent">
              <td>留学营销：{{ info.marketName || '' }}</td>
              <td>留学顾问：{{ info.adviserName || '' }}</td>
            </tr>
            <tr v-if="info.isStudent">
              <td>文案老师：{{ info.documentName || '' }}</td>
              <td>留学目的：{{ info.purpose || '' }}</td>
            </tr>
            <tr v-if="info.state === 'e' && info.reason">
              <td colspan="2">淘汰原因：{{ info.reason }}</td>
            </tr>
            <tr v-if="info.isJap">
              <td>日语顾问：{{ info.jpAdviserName || '' }}</td>
              <td>日语营销：{{ info.jpMarketName || '' }}</td>
            </tr>
            <tr v-if="info.isMingye">
              <td>鸣野顾问：{{ info.myAdviserName || '' }}</td>
              <td>鸣野营销：{{ info.myMarketName || '' }}</td>
            </tr>
            <tr v-if="info.isMingye">
              <td>升学阶段：{{ info.stage === 2 ? '升学时' : '赴日前' }}</td>
              <td></td>
            </tr>
          </table>
        </el-tab-pane>
        <el-tab-pane label="详细信息" name="second">
          <table
            class="
              myTable
              el-table
              el-table--fit
              el-table--striped
              el-table--border
              el-table--enable-row-hover
              el-table--enable-row-transition
            "
            style="width: 100%"
          >
            <tr>
              <td>留学时间：{{ info.abroadDate }}</td>
              <td>申请学校：{{ info.applySchool }}</td>
            </tr>
            <tr>
              <td>民族：{{ info.nation }}</td>
              <td>出生日期：{{ info.birthday }}</td>
            </tr>
            <tr>
              <td>赴日历史：{{ info.japanHistory }}</td>
              <td v-if="info.hjProvinceName">户籍：{{ info.hjProvinceName + " " + info.hjCityName }}</td>
            </tr>
            <tr>
              <td>高考成绩：{{ info.gaoKaoScore }}</td>
              <td>会考成绩：{{ info.huiKaoScore }}</td>
            </tr>
            <tr>
              <td v-if="info.zzProvinceName">
                家庭住址：{{
                  info.zzProvinceName + " " + info.zzCityName + " "
                }}
                <div>{{ info.zzDetail }}</div>
              </td>
              <td v-if="info.provinceName">
                现住住址：{{ info.provinceName + " " + info.cityName + " " }}
                <div>{{ info.siteDetail }}</div>
              </td>
            </tr>
            <tr>
              <td>学历：{{ info.eduBack }}</td>
              <td>电话：{{ info.mobile }}</td>
            </tr>
            <tr>
              <td>QQ：{{ info.qq }}</td>
              <td>邮箱：{{ info.email }}</td>
            </tr>
            <tr>
              <td>赴日目的：{{ info.purpose }}</td>
              <td></td>
            </tr>
            <tr>
              <td colspan="2">
                <el-divider content-position="left" style>日语能力</el-divider>
              </td>
            </tr>
            <tr>
              <td>日语情况：{{ info.japanese }}</td>
              <td>
                <!-- JTest考试：{{info.jtest}} -->
              </td>
            </tr>
            <tr>
              <td>学习机构：{{ info.learningInstituion }}</td>
              <td>
                学习时间：{{ info.lastExamStartDate }}-{{
                  info.lastExamEndDate
                }}
              </td>
            </tr>
          </table>
        </el-tab-pane>
        <el-tab-pane label="学历/职历/家庭" name="three">
          <!-- 学历 -->
          <el-divider content-position="left" style>学历</el-divider>
          <el-table
            v-loading="loading"
            :data="info.eduList"
            stripe
            border
            style="width: 100%"
          >
            <el-table-column prop="name" label="学历名称"></el-table-column>
            <el-table-column prop="school" label="学校名称"></el-table-column>
            <el-table-column
              prop="startDate"
              label="开始时间"
            ></el-table-column>
            <el-table-column prop="endDate" label="结束时间"></el-table-column>
            <el-table-column prop="xueZhi" label="学制"></el-table-column>
            <el-table-column prop="special" label="专业"></el-table-column>
          </el-table>
          <!-- 职历 -->
          <el-divider content-position="left" style>职历</el-divider>
          <el-table
            v-loading="loading"
            :data="info.postList"
            stripe
            border
            style="width: 100%"
          >
            <el-table-column prop="company" label="单位名称"></el-table-column>
            <el-table-column prop="post" label="职位名称"></el-table-column>
            <el-table-column
              prop="startDate"
              label="开始时间"
            ></el-table-column>
            <el-table-column prop="endDate" label="结束时间"></el-table-column>
          </el-table>

          <!-- 家庭成员 -->
          <el-divider content-position="left" style>家庭成员</el-divider>
          <el-table
            v-loading="loading"
            :data="info.familyList"
            stripe
            border
            style="width: 100%"
          >
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="relation" label="关系"></el-table-column>
            <el-table-column
              prop="post"
              label="单位和职位名称"
            ></el-table-column>
            <el-table-column prop="income" label="收入"></el-table-column>
            <el-table-column prop="mobile" label="电话"></el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="希望的大学" name="fourth" v-if="info.graApplySchool">
          <!-- 学历 -->
          <el-divider content-position="left" style>日本大学</el-divider>
          <el-table
            v-loading="loading"
            :data="info.graApplySchool"
            stripe
            border
            style="width: 100%"
          >
            <el-table-column prop="school" label="学校名称"></el-table-column>
            <el-table-column prop="special" label="专业名字"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
//学生信息展示
export default {
  props: ["stuid"],
  data() {
    return {
      info: {}, //用户基本信息
      dialogVisible: false,
      activeName: "first",
      loading: false,
    };
  },
  watch: {
    stuid: function (newVal, oldVal) {
      var _this = this;
      _this.activeName = 'first';
      if (newVal > 0) {
        var link = url.getStu("GetModelDetail");
        $.get(link, { id: newVal }, (res) => {
          if (res && typeof res.graApplySchool === 'string' && res.graApplySchool) {
              res.graApplySchool = JSON.parse(res.graApplySchool);
          }
          _this.info = res || {};
          _this.dialogVisible = true;
        });
      }
    },
  },
};
</script>


<style scoped>
.myTable td {
  text-indent: 10px;
}
.myTable tr td:last-child {
  border-right: 0px;
}
.myTable tr:last-child td {
  border-bottom: 0px;
}
</style>
